import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, updateBalance } from "../../../redux/slices/profileSlice";
import ProfileMenuItem from "./ProfileMenuItem";
import { BankIcon, HelpIcon, LogoutSvg, MyAccountIcon, WalletSvg, UserSvg, NoteBlackSvg } from "../../../svgFile";
import { defaultConfig } from "../../../config";
import { queryClient } from "../../../providers/QueryProvider";
import { removeFcmToken } from "../../firebaseConfig";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isLoggedIn, menuItems } = useSelector((state) => state.profile);
  const [imageError, setImageError] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const token = localStorage.getItem("accessToken")

  useEffect(() => {
    if (user?.profileImage && user?.profileImage !== "" && !imageError) {
      setProfileImage(user.profileImage);
    } else {
      setProfileImage(null);
    }
  }, [user?.profileImage, imageError]);

  const handleLogout = async () => {
  await removeFcmToken();          
  queryClient.clear();
  dispatch(logout());
  navigate("/");
};

  const handleMenuItemClick = (item) => {
    switch (item.label) {
      case "My Account":
        navigate("/my-account");
        break;
      case "Transactions":
        navigate("/transactions");
        break;
      case "Invoices & PODs":
        navigate("/invoices-pods");
        break;
      case "Bank Details":
        navigate("/bank-details");
        break;
      case "Help":
        navigate("/help");
        break;
      case "Company Info":
        navigate("/company-info");
        break;
      default:
        break;
    }
  };

  const getIcon = (iconName) => {
    switch (iconName) {
      case "myAccount":
        return <MyAccountIcon />;
      case "wallet":
        return <WalletSvg />;
      case "bank":
        return <BankIcon />;
      case "invoice":
        return <NoteBlackSvg />;
      case "help":
        return <HelpIcon />;
      default:
        return null;
    }
  };

  const handleImageError = () => {
    setImageError(true);
    setProfileImage(null);
  };
  const getAvatarImage = () => {
    if (user?.profileImage && user?.profileImage !== "") {
      return defaultConfig.imageUrl + user?.profileImage;
    }
    return null;
  };

  const getUserInitials = () => {
    if (user?.fullName) {
      return user?.fullName.charAt(0).toUpperCase();
    }
    return "U";
  };

  if (!token) {
    return null;
  }
  return (
    <div className="dropdown profile-dropdown">
      <button
        className="notification-btn dropdown-toggle p-0"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {profileImage ? (
          <img
            src={defaultConfig.imageUrl + profileImage}
            alt="Profile"
            onError={handleImageError}
            style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
          />
        ) : (
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: '#FF6B6B',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            {getUserInitials()}
          </div>
        )}
      </button>

      <div className="dropdown-menu dropdown-menu-end">
        <div className="d-flex align-items-center p-3 border-bottom gap-2 profile-drop-top">
          {getAvatarImage() && !imageError ? (
            <img
              src={getAvatarImage()}
              alt="User"
              onError={handleImageError}
              style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
            />
          ) : (
            <div
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: '#FF6B6B',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '20px',
                fontWeight: 'bold'
              }}
            >
              {getUserInitials()}
            </div>
          )}
          <div>
            <h3 className="mb-1 text-15 font-medium">{user?.fullName || "User"}</h3>
            <h3 className="mb-0 text-13 font-400">{user?.role || "N/A"}</h3>
          </div>
        </div>

        <div className="px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
          <p className="text-15 font-400 mb-0 text-dark">Balance</p>
          <h6 className="text-15 font-500 mb-0 text-dark red-text">${user?.wallet?.amount || "0.00"}</h6>
        </div>

        <ul className="list-unstyled mb-0 p-2 profile-down-list">
          {menuItems?.map((item) => (
            <ProfileMenuItem
              key={item.id}
              icon={getIcon(item.icon)}
              label={item.label}
              onClick={() => handleMenuItemClick(item)}
              path={item.path}
            />
          ))}

          <li>
            <hr className="dropdown-divider" />
          </li>

          <ProfileMenuItem
            icon={<LogoutSvg />}
            label="Logout"
            onClick={handleLogout}
          />
        </ul>
      </div>
    </div>
  );
};

export default ProfileDropdown;